import React from 'react';

const LatexDisplay = ({ latexContent }) => {
  return (
    <div
      style={{
        marginTop: '20px',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f8f9fa',
      }}
    >
      <h3>Generated LaTeX</h3>
      <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
        {latexContent || 'No LaTeX content generated yet.'}
      </pre>
    </div>
  );
};

export default LatexDisplay;